module.exports = "./app-dist/templates/distributor.component.45a924dfd5688e8ddc1c8992f8242c85.html";